import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  JustifyContent,
  Space,
  ZIndex,
} from '@gousto-internal/citrus-react'

import * as trackingKeys from 'actions/trackingKeys'
import type { View } from 'utils/view'

import { BrowseCTAContainer } from '../../BrowseCTA'
import { BrowseCTAButtonContainer } from '../../BrowseCTAButton'
import { BasketComprehensionSummary } from '../BasketComprehensionSummary'
import { CheckoutButton } from '../CheckoutButton'
import { VisualBasket } from '../VisualBasket'

type Props = {
  showBrowseCTA: boolean
  view: View
}

export const BasketComprehensionBanner = ({ showBrowseCTA, view }: Props) => {
  return (
    <section>
      <Box
        alignItems={[AlignItems.Stretch, null, AlignItems.Center]}
        bg={Color.ColdGrey_800}
        bottom="0"
        boxShadow="0px -4px 8px rgba(0, 0, 0, 0.16)"
        display={Display.Flex}
        flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
        left="0"
        height={['146px', '88px', '88px']}
        paddingH={[3, null, 10]}
        paddingV={[2, null, 0]}
        position={DisplayPosition.Fixed}
        width="100%"
        zIndex={ZIndex.Toast}
      >
        <VisualBasket />

        <Box
          alignItems={AlignItems.Center}
          display={Display.Flex}
          flexGrow={1}
          height={['auto', null, '100%']}
          justifyContent={[JustifyContent.SpaceBetween, null, JustifyContent.FlexEnd]}
          width={['100%', null, 'auto']}
          data-no-code="boxSummaryPriceContainer"
        >
          <BasketComprehensionSummary />

          {showBrowseCTA ? (
            <>
              <BrowseCTAButtonContainer view={view} />
              <BrowseCTAContainer view={view} />
            </>
          ) : (
            <>
              <Space direction="horizontal" size={4} />
              <CheckoutButton
                view={view}
                section={trackingKeys.menu}
                hideCounter
                isBasketComprehensionEnabled
              />
            </>
          )}
        </Box>
      </Box>
    </section>
  )
}
